const state = {
    history: [] as Array<{ name: string; params?: any }>
}

const mutations = {
    ADD_HISTORY(state: any, routeInfo: { name: string; params?: any }) {
        state.history.push(routeInfo)
    },
    POP_HISTORY(state: any) {
        state.history.pop()
    }
}

const getters = {
    lastPage: (state: any) => {
        return state.history.length > 0 ? state.history[state.history.length - 1] : null
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
}